import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, Teleport as _Teleport, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col flex-grow h-full pb-4" }
const _hoisted_2 = {
  key: 0,
  style: {"z-index":"99999"},
  class: "fixed top-0 left-0 w-full h-full bg-opacity-50 bg-dark"
}
const _hoisted_3 = { class: "fixed z-50 w-full px-6 py-4 text-center transform -translate-x-1/2 -translate-y-1/2 rounded md:w-max top-1/2 left-1/2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "opacity-50 material-icons-outlined text-lightText"
}, " timer_off ", -1)
const _hoisted_5 = {
  class: "pt-1 mx-auto rounded-t md:bg-transparent text-lightText md:px-2",
  style: {"text-shadow":"0.5px 0.5px 4px rgb(0 0 0 / 50%)"}
}
const _hoisted_6 = {
  class: "pb-1 rounded-b md:bg-transparent text-lightText md:mx-2 md:px-2",
  style: {"text-shadow":"0.5px 0.5px 4px rgb(0 0 0 / 50%)"}
}
const _hoisted_7 = { class: "flex items-start mt-1 space-x-10" }
const _hoisted_8 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"18px"}
}, "arrow_back", -1)
const _hoisted_10 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_11 = {
  key: 0,
  class: "relative w-full bg-light bg-opacity-50 py-2 mb-8 -mt-10 px-2"
}
const _hoisted_12 = { class: "select-none uppercase text-muted text-xs mt-2 mr-2 absolute top-0 right-0" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "mb-0" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "flex items-center w-full mt-8" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined mt-0.5 mr-0.5 text-base" }, " chevron_left ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined mt-0.5 ml-0.5 text-base" }, " chevron_right ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined mt-0.5 text-base mr-1" }, " check ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloudSaveStatus = _resolveComponent("CloudSaveStatus")!
  const _component_Countdown = _resolveComponent("Countdown")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_SlotSkeleton = _resolveComponent("SlotSkeleton")!
  const _component_AbstractEventParticipationSlot = _resolveComponent("AbstractEventParticipationSlot")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showTimeUpBackdrop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("event_participation_page.times_up")), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("event_participation_page.all_answers_saved")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.mounted)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "#main-student-header-right"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_CloudSaveStatus, {
              saving: _ctx.saving,
              hadError: _ctx.savingError
            }, null, 8, ["saving", "hadError"]),
            (_ctx.currentEventParticipation.time_limit_timestamp !== null)
              ? _withDirectives((_openBlock(), _createBlock(_component_Countdown, {
                  key: 0,
                  onTimeUp: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onTimeUp())),
                  endTimestamp: _ctx.currentEventParticipation.time_limit_timestamp,
                  isInitialized: _ctx.runTimer
                }, null, 8, ["endTimestamp", "isInitialized"])), [
                  [_vShow, _ctx.currentEventParticipation.time_limit_timestamp !== null && _ctx.runTimer]
                ])
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.journeySlug)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_Btn, {
            onClick: _ctx.goToCourseJourney,
            variant: "ghost",
            size: "sm",
            class: "flex items-center gap-1"
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("learning_journey.back_to_journey")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.firstLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_SlotSkeleton, { class: "mb-24" }),
          _createVNode(_component_SlotSkeleton, { class: "mb-24" }),
          _createVNode(_component_SlotSkeleton, { class: "mb-24" }),
          _createVNode(_component_SlotSkeleton)
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.currentEventParticipation.slots, (slot, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass([{
				'flex-grow': _ctx.oneExerciseAtATime,
				'mb-10 pb-10':
					index !== _ctx.currentEventParticipation.slots.length - 1 && !_ctx.oneExerciseAtATime,
				'pb-0 border-b-0': index === _ctx.currentEventParticipation.slots.length - 1,
			}, ""]),
            key: 'p-' + _ctx.currentEventParticipation.id + '-s-' + slot.id
          }, [
            (
					_ctx.currentEventParticipation.event.event_type ===
						_ctx.EventType.SELF_SERVICE_PRACTICE && index === 1
				)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("misc.ads")), 1),
                  _withDirectives(_createElementVNode("div", {
                    class: "hidden md:block",
                    innerHTML: _ctx.ads3Code
                  }, null, 8, _hoisted_13), [
                    [_vShow, _ctx.ads3Code]
                  ]),
                  _withDirectives(_createElementVNode("div", {
                    class: "md:hidden",
                    innerHTML: _ctx.adsMobileCode
                  }, null, 8, _hoisted_14), [
                    [_vShow, _ctx.adsMobileCode]
                  ])
                ], 512)), [
                  [_vShow, _ctx.ads3Code || _ctx.adsMobileCode]
                ])
              : _createCommentVNode("", true),
            _createVNode(_component_AbstractEventParticipationSlot, {
              modelValue: slot,
              onUpdateSelectedChoices: ($event: any) => (_ctx.onChange($event.slot, 'selected_choices', $event.payload)),
              onUpdateSubmission: ($event: any) => (_ctx.onUpdateSubmission($event.slot, $event.payload)),
              onRunCode: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRunCode($event))),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onBlur($event))),
              allowEditSubmission: true,
              saving: _ctx.saving,
              showTags: 
					_ctx.currentEventParticipation.event.event_type === _ctx.EventType.SELF_SERVICE_PRACTICE
				,
              showHintButton: 
					_ctx.hasFeatures(['exercise_hints']) &&
					_ctx.currentEventParticipation.event.event_type === _ctx.EventType.SELF_SERVICE_PRACTICE
				
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", _hoisted_15, [
                  _createTextVNode(_toDisplayString(_ctx.$t("event_participation_page.exercise")) + " " + _toDisplayString(slot.slot_number + 1) + " ", 1),
                  (_ctx.oneExerciseAtATime)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("event_participation_page.of")) + " " + _toDisplayString(_ctx.currentEventParticipation.last_slot_number + 1), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdateSelectedChoices", "onUpdateSubmission", "saving", "showTags", "showHintButton"])
          ], 2))
        }), 128)),
    _createElementVNode("div", _hoisted_17, [
      (_ctx.goingBackAllowed)
        ? (_openBlock(), _createBlock(_component_Btn, {
            key: 0,
            class: "",
            onClick: _ctx.onGoBack,
            disabled: 
					!_ctx.canGoBack ||
					_ctx.goingBack ||
					_ctx.goingForward ||
					_ctx.metaStore.loading ||
					_ctx.schedulingCodeRun
				
          }, {
            default: _withCtx(() => [
              _hoisted_18,
              _createTextVNode(" " + _toDisplayString(_ctx.goingBack ? _ctx.$t("misc.wait") : _ctx.$t("event_participation_page.previous_exercise")), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]))
        : _createCommentVNode("", true),
      (_ctx.canGoForward)
        ? (_openBlock(), _createBlock(_component_Btn, {
            key: 1,
            class: "ml-auto",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goingBackAllowed ? _ctx.onGoForward() : _ctx.confirmGoForward())),
            disabled: _ctx.goingForward || _ctx.goingBack || _ctx.metaStore.loading || _ctx.schedulingCodeRun
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.goingForward ? _ctx.$t("misc.wait") : _ctx.$t("event_participation_page.next_exercise")) + " ", 1),
              _hoisted_19
            ]),
            _: 1
          }, 8, ["disabled"]))
        : (_ctx.canTurnIn)
          ? (_openBlock(), _createBlock(_component_Btn, {
              key: 2,
              class: "ml-auto",
              onClick: _ctx.confirmTurnIn,
              variant: 'success',
              disabled: _ctx.metaStore.loading || _ctx.goingBack || _ctx.turningIn
            }, {
              default: _withCtx(() => [
                _hoisted_20,
                _createTextVNode(_toDisplayString(_ctx.turningIn ? _ctx.$t("misc.wait") : _ctx.$t("event_participation_page.turn_in")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showConfirmDialog,
      yesText: _ctx.dialogData.yesText,
      noText: _ctx.$t('dialog.default_cancel_text'),
      onYes: _ctx.dialogData.onYes,
      onNo: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showConfirmDialog = false))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.dialogData.title), 1)
      ]),
      body: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.dialogData.text), 1)
      ]),
      _: 1
    }, 8, ["showDialog", "yesText", "noText", "onYes"])
  ]))
}